import axios from "axios";
import {getToken} from "../Common";
import { ORDER_API, BACK_OFFICE_API } from "constants/apiUrls";


// 주문리스트 조회
export async function getOrderListApi(shopId, data) {
  try {
    if(data) {
      const response = await axios.get(`${BACK_OFFICE_API}/v2/order/shop/list2`, {
        params: data
      });
      return response.data;
    }
  } catch (e) {
    console.log(e);
  }
}

export async function getOrderListCountApi(shopId, data) {
  try {
    if(data) {
      const response = await axios.get(`${BACK_OFFICE_API}/v2/order/shop/list2/count`, {
        params: data
      });
      return response.data[0].count;
    }
  } catch (e) {
    console.log(e);
  }
}

export async function getOrderDetailApi(id) {
  const token = getToken();

  try {
    if(id) {
      const response = await axios.get(`${ORDER_API}/order/v2/${id}`, {
        headers: {Authorization: `Bearer ${token}`}
      });
      return response.data;
    }
  } catch (e) {
    console.log(e);
  }
}